import { resolveBrandRules } from '@ngb-frontend/shared/rules'
import {
  TVehicleIdentifier,
  type QueryParams,
  type QueryConfig,
} from '@ngb-frontend/shared/types'

import { getJourneyType } from './getJourneyType'
import { getUserType } from './getUserType'

export const getQueryConfig = (
  queryParams?: QueryParams | null,
): QueryConfig | undefined => {
  if (!queryParams) return

  const { ilan, licensePlate } = queryParams
  const userType = getUserType(queryParams.systemCode)
  const journey = getJourneyType(userType)

  return {
    ...queryParams,
    bare: queryParams, // without helpers
    vehicleIdentifier: {
      type: ilan ? TVehicleIdentifier.ILAN : TVehicleIdentifier.REGISTRATION,
      // We don't store a query if none of the 2 is present
      value: ilan || licensePlate || '',
    },
    userType,
    journey,
    theme: resolveBrandRules(queryParams.country).theme,
  }
}
